import * as React from 'react';

import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import { AdfoxContextProvider, TAdfoxContextProviderProps } from '../../context/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: TAdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
  place__DEPRECATED: 'CardKP',
  name__DEPRECATED: 'CardKP_Footer_TGB',
};
const P_PARAMS: TAdfoxContextProviderProps['pParams'] = { p1: 'ddcga', p2: 'fkhj' };
const SIZE: TAdfoxContextProviderProps['size'] = { width: '100%', height: 276 };

export const TgbBottomBannerContainer: React.FC = () => {
  return (
    <AdfoxContextProvider
      bannerPlace="bottom"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    >
      <AdfoxBannerContainer />
    </AdfoxContextProvider>
  );
};
